import Vue from 'vue';
import VueI18n from 'vue-i18n';
import enLocale from './en';
import esLocale from './es';
import vaLocale from './va';

Vue.use(VueI18n);

const messages = {
  es: esLocale,
  en: enLocale,
  va: vaLocale,
};

const i18n = new VueI18n({
  locale: 'es',
  fallbackLocale: 'en',
  messages,
});

export default i18n;
